/**
 * @file preview-options.ts
 * @description Переключатели предпросмотра баннера (phase19.16, Р3г;
 * uiux-r3g-consent-texts §3): вид, форма, ширина. Реестры — данными:
 * новая форма или вид = запись, разметка их только перечисляет.
 */

import type { SiteConsentBannerKind } from "@chaiberi/shared";

import type { PreviewServicesPreset } from "../../../lib/platform/consent-preview";

/** Форма образца: полоса, карточка, компактная полоса, окно «Настроить». */
export type PreviewForm = "bar" | "card" | "compact" | "settings";

/** Ширина образца: телефон 360 или широкий экран. */
export type PreviewWidth = "narrow" | "wide";

export const PREVIEW_VIEW_OPTIONS: ReadonlyArray<{ value: SiteConsentBannerKind; label: string }> = [
  { value: "consent", label: "Согласие" },
  { value: "notice", label: "Уведомление" },
  { value: "info", label: "Без счётчиков" },
];

export const PREVIEW_FORM_OPTIONS: ReadonlyArray<{ value: PreviewForm; label: string }> = [
  { value: "bar", label: "Полоса" },
  { value: "card", label: "Карточка" },
  { value: "compact", label: "Компактная" },
  { value: "settings", label: "Настроить" },
];

/** Состояние предпросмотра. */
export interface PreviewState {
  view: SiteConsentBannerKind;
  form: PreviewForm;
  services: PreviewServicesPreset;
  webvisor: boolean;
  width: PreviewWidth;
}

export const DEFAULT_PREVIEW_STATE: PreviewState = {
  view: "consent",
  form: "bar",
  services: "metrika_vk",
  webvisor: false,
  width: "wide",
};

/** Кнопки баннера вида в порядке показа (как на витрине, ConsentBannerView). */
export type PreviewButton = "acceptAll" | "necessaryOnly" | "configure" | "ok" | "refuse";

export const PREVIEW_BUTTONS: Readonly<Record<SiteConsentBannerKind, readonly PreviewButton[]>> = {
  consent: ["acceptAll", "necessaryOnly", "configure"],
  notice: ["ok", "refuse", "configure"],
  info: ["ok"],
};
